// eslint-disable-next-line sonarjs/cognitive-complexity
import { isMobile } from '../../utils/mediaQueries'

// eslint-disable-next-line sonarjs/cognitive-complexity
;(function () {
  'use strict'
  function onDocumentReady() {
    let breadcrumbsCollapsed = false

    function updateBreadcrumbs() {
      const isCollapsed = !breadcrumbsCollapsed && isMobile()
      const breadcrumbList = document.querySelector('.cmp-breadcrumb__list')

      const existingToggle = breadcrumbList.querySelector('.cmp-breadcrumb__item--toggle')
      if (existingToggle) {
        existingToggle.remove()
      }

      if (isCollapsed) {
        breadcrumbList.classList.add('cmp-breadcrumb__list--collapsed')

        const toggleItem = document.createElement('li')
        toggleItem.className = 'cmp-breadcrumb__item--toggle'
        toggleItem.textContent = '...'
        toggleItem.tabIndex = 0
        toggleItem.setAttribute('role', 'menuitem')

        toggleItem.addEventListener('click', handleClick)
        toggleItem.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            handleClick()
          }
        })

        const lastItem = breadcrumbList.lastElementChild
        lastItem.before(toggleItem)
      } else {
        breadcrumbList.classList.remove('cmp-breadcrumb__list--collapsed')
      }
    }

    function handleClick() {
      breadcrumbsCollapsed = true
      updateBreadcrumbs()
    }

    window.addEventListener('resize', updateBreadcrumbs)
    updateBreadcrumbs()
  }

  if (document.readyState !== 'loading') {
    onDocumentReady()
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady)
  }
})()
